import React from "react";
import { Mail } from "lucide-react";

interface EmailDisplayProps {
  email: string;
  className?: string;
  style?: "default" | "instructor";
}

const EmailDisplay = ({ 
  email, 
  className = "", 
  style = "default" 
}: EmailDisplayProps) => {
  if (style === "instructor") {
    return (
      <div className={`w-full ${className}`}>
        <div className="flex items-center gap-1.5 text-gray-600">
          <Mail className="h-4 w-4 text-blue-600" />
          <span className="text-sm font-medium truncate">{email}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full bg-gray-50 p-3 rounded-lg flex items-center gap-2 ${className}`}>
      <Mail className="w-4 h-4 text-gray-400" />
      <div>
        <p className="text-xs font-medium text-gray-500">Email</p>
        <p className="text-sm font-medium text-gray-700 break-all">{email}</p>
      </div>
    </div>
  );
};

export default EmailDisplay; 